export interface RoleFlags {
  is_nominated: boolean;
  is_executor: boolean;
  is_administrator: boolean;
  is_trustee: boolean;
}

export type PrimaryLegalRole = "executor" | "administrator" | "trustee" | null;

export function toPrimaryLegalRole(flags: RoleFlags): PrimaryLegalRole {
  if (flags.is_trustee) return "trustee";
  if (flags.is_executor) return "executor";
  if (flags.is_administrator) return "administrator";
  return null;
}

export function toLegalRoleLabels(flags: RoleFlags): string[] {
  const roles: string[] = [];
  if (flags.is_executor) roles.push("Executor");
  if (flags.is_administrator) roles.push("Administrator");
  if (flags.is_trustee) roles.push("Trustee");
  if (flags.is_nominated && !flags.is_executor && !flags.is_administrator && !flags.is_trustee)
    roles.push("Nominated Executor");
  return roles;
}

const ROLE_FLAG_LABELS: [keyof RoleFlags, string][] = [
  ["is_executor", "executor"],
  ["is_administrator", "administrator"],
  ["is_trustee", "trustee"],
  ["is_nominated", "nominated executor"],
];

/** The user_estates flag a legal_role entry stands for, in any spelling ("Nominated Executor", "nominated-executor"). */
export function toRoleFlag(role: string): keyof RoleFlags | null {
  const normalized = role.toLowerCase().replace(/-/g, " ");
  return ROLE_FLAG_LABELS.find(([, label]) => label === normalized)?.[0] ?? null;
}
